import { render, staticRenderFns } from "./CreateSavedQueryModal.vue?vue&type=template&id=d2316c62"
import script from "./CreateSavedQueryModal.vue?vue&type=script&lang=js"
export * from "./CreateSavedQueryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports